<template>
  <div :class="classes()"><slot /></div>
</template>

<script>
export default {
  name: 'Container',
  props: {
    centered: Boolean,
    verticalCenter: Boolean,
    verticalEnd: Boolean,
    mobileFullWidth: Boolean,
    background: {
      type: String,
      validator: (val) => ['primaryLightest'].includes(val),
    },
    padded: Boolean,
    autoHeight: Boolean,
    size: {
      type: String,
      default: 'l',
      validator: (val) => ['l', 'm', 's'].includes(val),
    },
  },
  data() {
    return {
      el: 'o-container',
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--centered`]: this.centered,
          [`${el}--verticalCenter`]: this.verticalCenter,
          [`${el}--verticalEnd`]: this.verticalEnd,
          [`${el}--mobileFullWidth`]: this.mobileFullWidth,
          [`${el}--autoHeight`]: this.autoHeight,
          [`${el}--${this.background}`]: this.background,
          [`${el}--${this.size}`]: this.size,
          [`${el}--padded`]: this.padded,
        };
      },
    };
  },
};
</script>
